export const getDateDifference = ({
  start,
  end,
  format,
}: {
  start: Date;
  end: Date;
  format: 'days' | 'hours' | 'minutes' | 'seconds' | 'milliseconds';
}): number => {
  const timeDiffInMs = end.getTime() - start.getTime();

  switch (format) {
    case 'days':
      return Math.floor(timeDiffInMs / (1000 * 60 * 60 * 24));
      break;
    case 'hours':
      return Math.ceil(timeDiffInMs / (1000 * 60 * 60));
      break;
    case 'minutes':
      return Math.ceil(timeDiffInMs / (1000 * 60));
      break;
    case 'seconds':
      return Math.ceil(timeDiffInMs / 1000);
      break;
    case 'milliseconds':
      return timeDiffInMs;
      break;
    default:
      return 0;
      break;
  }
};
